import { render } from "./subjectFusion.vue?vue&type=template&id=7f1c4fbb&scoped=true"
import script from "./subjectFusion.vue?vue&type=script&lang=js"
export * from "./subjectFusion.vue?vue&type=script&lang=js"

import "./subjectFusion.vue?vue&type=style&index=0&id=7f1c4fbb&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f1c4fbb"]])

export default __exports__